<template>
  <div class="sheduel-msg">
    <div class="sheduel-msg-head " style="height: 34px">
      <strong></strong>
    </div>

    <div class="sheduel-msg-body">

      <ul class="list-msgs" v-if="messages.length>0">
        <li class="message" v-for="(message,key) in messages" :class="{'my-message':auth_id===message.sender_id}">
          <div class="mes-avatar text-uppercase">
            {{getNameFirst((message.user)?message.user.name:'')}}
          </div>
          <div class="message-bubble">
            <div class="bubble-meta">
              <span class="name text-capitalize">{{  (message.user)?message.user.name:'' }}</span>
<!--              <span class="timestamp">07.21.2022, 3:11 p.m.</span>-->
              <span class="timestamp">{{ message.created_at | moment('DD.MM.Y HH:mm') }}</span>
            </div>
            <div class="message-con">
              <p>{{ message.message }}</p>
            </div>
            <span class="btn btn-sm btn-outline-light" v-if="auth_id===message.created_by" @click="deleteMessage(message.id)">Delete comment</span>
          </div>
        </li>
      </ul>
      <div class="no-message-box" v-else>
        <i class="ico-chat"></i>
        {{scheduleDate}}
        <p><strong>There are no messages</strong></p>
        <span>Write a message</span>
      </div>
    </div>

    <div class="sheduel-msg-tfoot">
      <div class="msg-tfoot-head">

        <span class="mes-avatar text-uppercase"> {{getNameFirst(auth_name)}}</span>

        <input class="form-control" v-model="formData.message" type="text" placeholder="Write a message">
      </div>
      <div class="msg-tfoot-body">
        <div class="tfoot-body-top">
          <div class="checkbox-mesg">
            <input type="checkbox" id="snd-msg">
            <label for="snd-msg">Send message as SMS to receivers</label>
          </div>
          <span class="btn-info btn btn-sm" @click="postMessage">Send message</span>
        </div>

<!--        <div class="tfoot-body-bottom">
          <strong class="notified-act">People notified on activity</strong>
          <div class="ntified-snd">
            <ul>
              <li><span class="mes-avatar">IA</span></li>
              <li><span class="mes-avatar">SA</span></li>
            </ul>
            <span class="btn btn-sm btn-outline-info">Add/Remove</span>
          </div>
          <span class="small-text">2 people get's a notification on new activity in this thread. Including yourself. <a class="text-danger">Remove me</a></span>
        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import axios from "axios";
export default {
  name: 'messages',
  props: ["scheduleDate"],
  data() {
    return {
      auth_name: this.$store.getters.getUser.name,
      auth_id: this.$store.getters.getUser.id,
      company_id: this.$store.getters.getSelectedCompany.id,
      roster_schedule_id: this.$route.params.id,
      date: new Date(),
      messages: [],
      formData: {
        title: '',
        message: '',
      },
    }
  },
  created(){
    this.getMessageByDate();
  },
  methods:{
    getNameFirst(name){
      return this.getNameFirstLetter(name)
    },
    getMessageByDate(){
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          date: this.scheduleDate,
          roster_schedule_id: this.roster_schedule_id
        },
        url: this.$messagesByDate,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.status == 200) {
         this.messages= res.data.result.messageAllByDate;
        }
      });
    },
    postMessage(){
      axios.post(this.$messages,
        {
          company_id: this.company_id,
          roster_schedule_id: this.roster_schedule_id,
          date: this.scheduleDate,
          title: this.formData.title,
          message: this.formData.message,

        }, {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status == 200) {
            this.formData={};
            this.getMessageByDate();
          }
        });
    },
    deleteMessage(id){
      if (confirm("Do you really want to delete?")) {
        axios.delete(this.$messages + '/' + id,
          {headers: this.getAuthHeader()})
          .then((res) => {
            if (res.status == 200) {
              this.getMessageByDate();
            }
          });
      }
    }
  }

}
</script>
